import axios from 'axios';
import { getAuthToken } from 'utils/auth';

const authTokens = getAuthToken();
const BASE_URL_API_REPORTS = `${process.env.REACT_APP_BASE_URL_REPORTS_API}/api`;
const authorization = authTokens?.accessToken ? { authorization: `Bearer ${authTokens.accessToken}` } : undefined;
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Accept-Language': 'es-MX',
  ...authorization,
};

export const reportsApi = axios.create({
  baseURL: BASE_URL_API_REPORTS,
  headers,
});
